module.exports = __webpack_public_path__ + "img/Nischay Dhiman.075c9b69.jpg";